import { render, staticRenderFns } from "./NcrMainDetails.vue?vue&type=template&id=e1be33f0&scoped=true&"
import script from "./NcrMainDetails.vue?vue&type=script&lang=js&"
export * from "./NcrMainDetails.vue?vue&type=script&lang=js&"
import style0 from "./NcrMainDetails.vue?vue&type=style&index=0&id=e1be33f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1be33f0",
  null
  
)

export default component.exports